<div class="card card-icon mb-4">
    <div class="row gx-0">
        <div class="col-auto card-icon-aside" [ngClass]="iconBackground"><ng-content select=".card-icon"></ng-content></div>
        <div class="col"><ng-content select=".card-body"></ng-content></div>
    </div>
</div>
